// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mobile-only-bottom-sheet-transition-enter,.mobile-only-bottom-sheet-transition-leave-to{transform:translateY(100%)}@media only screen and (max-width:959px){.mobile-only-bottom-sheet.v-dialog{align-self:flex-end;border-radius:0;flex:0 1 auto;margin:0;overflow:visible}.mobile-only-bottom-sheet.v-dialog>.v-sheet{border-top-left-radius:24px;border-top-right-radius:24px}}", ""]);
// Exports
module.exports = exports;
